import { Text } from '$components'
import { SidebarLink } from './link'
import { SidebarGroup } from './group'
import { useAuth } from '$features/auth/hooks/use-auth'
import { Role } from '$api-client/types.gen'
import { RequireRole } from '$components'
import { Fragment } from 'react'
import { Config } from '$config/app'

export const SettingsMenuOptions = () => {
  const { user } = useAuth()

  return (
    <Fragment>
      <RequireRole roles={[Role.SUPER_ADMIN, Role.ADMIN]}>
        <SettingsSidebar.Group title="Organisation">
          <SettingsSidebar.Link to="general">
            General
          </SettingsSidebar.Link>

          <SettingsSidebar.Link to="online-booking">
            Online Booking
          </SettingsSidebar.Link>

          <SettingsSidebar.Link to="notification">
            Notifications
          </SettingsSidebar.Link>

          <RequireRole roles={[Role.SUPER_ADMIN]}>
            <SettingsSidebar.Link
              to={Config.getStripeBillingUrl(user!.email)}
              external
            >
              Billing
            </SettingsSidebar.Link>
          </RequireRole>
        </SettingsSidebar.Group>

        <SettingsSidebar.Group title="Pet Options">
          <SettingsSidebar.Link to="pet-options/sizes">
            Sizes
          </SettingsSidebar.Link>

          <SettingsSidebar.Link to="pet-options/coats">
            Coat Types
          </SettingsSidebar.Link>
        </SettingsSidebar.Group>
      </RequireRole>

      <SettingsSidebar.Group title="Personal">
        <SettingsSidebar.Link to="profile">
          Profile
        </SettingsSidebar.Link>
      </SettingsSidebar.Group>
    </Fragment>
  )
}

export function SettingsSidebar() {
  return (
    <div className="hidden md:flex min-w-72 max-w-72 bg-surface border-r border-border h-full py-stack-roomy px-stack">
      <div className="flex flex-col w-full">
        <Text
          type="h3"
          as="h2"
          className="px-stack mb-stack-roomy"
        >
          Settings
        </Text>

        <SettingsMenuOptions />
      </div>
    </div>
  )
}

SettingsSidebar.Group = SidebarGroup
SettingsSidebar.Link = SidebarLink
